// ADR 30.9.26ai §2 — the installs that drew a relay `404` this session.
//
// H1 §6: "`Removed` sticks for the session". A2 answers 404 while
// `enable_apps` is dark for the caller or the owner, but `GET /apps/installs`
// is never gated, so a re-list returns the same install and a slot that only
// invalidated `['app-installs']` would loop render → 404 → re-list → render.
// Every slot filters the list through this set **before** `appForSlot`.
//
// Memory only: a reload forgets it, and so does every sign-out (the
// `useAccountStorageWipe` listener). A confirmed uninstall adds the id too.

const removed = new Set<string>()

export function markRemoved(installId: string): void {
  removed.add(installId)
}

export function withoutRemoved<T extends { id: string }>(installs: readonly T[]): T[] {
  return installs.filter((install) => !removed.has(install.id))
}

export function clearRemovedInstalls(): void {
  removed.clear()
}
